import { memo } from 'react';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Appointments = () => {
  return (
    <div/>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Appointments {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);